export default "__VITE_ASSET__BpYj5Fxv__"